module.exports = __webpack_public_path__ + "assets/icon-nav-business-insights-component.4dba1cdc.svg";